function permissionsForProject(accessContext, projectId) {
  const project = (accessContext?.projects || []).find((item) => item.project_id === projectId);
  return new Set(project?.permissions || []);
}

export function getReportReopenAction(report, accessContext) {
  if (!report || !accessContext) return null;

  const permissions = permissionsForProject(accessContext, report.project_id);
  const isOriginalSubmitter = accessContext.actor_id === report.submitted_by_actor_id;
  const canSubmit = permissions.has("report_submit");
  const canEdit = permissions.has("report_edit");
  const canApprove = permissions.has("report_approve");

  if (
    report.status === "submitted" &&
    ((isOriginalSubmitter && canSubmit) || canEdit || canApprove)
  ) {
    return {
      kind: "withdraw",
      label: "Heropenen voor correctie",
      prompt:
        "Waarom wordt dit ingediende rapport heropend? Deze reden wordt in de audittrail opgeslagen.",
    };
  }

  if (report.status === "approved" && canApprove) {
    return {
      kind: "reopen-approved",
      label: "Goedkeuring intrekken",
      prompt:
        "Waarom wordt de goedkeuring ingetrokken? Deze reden wordt in de audittrail opgeslagen.",
    };
  }

  return null;
}

export function getReportDeleteAction(report, accessContext) {
  if (!report || !accessContext || report.deleted_at) return null;

  const permissions = permissionsForProject(accessContext, report.project_id);
  if (!permissions.has("report_delete")) return null;

  return {
    kind: "delete",
    label: "Testrapport verwijderen",
    prompt:
      "Waarom wordt dit rapport verwijderd? Gebruik dit alleen voor een test- of ongeldig rapport. De reden wordt in de audittrail opgeslagen.",
    confirmation:
      "Weet je zeker dat dit rapport uit alle normale overzichten moet verdwijnen? Deze handeling is alleen administratief herstelbaar.",
  };
}

export function getReportPurgeAction(report, accessContext) {
  if (!report || !accessContext) return null;

  const permissions = permissionsForProject(accessContext, report.project_id);
  if (!permissions.has("report_purge")) return null;
  if ((report.assets || []).length > 0) return null;

  return {
    kind: "purge",
    label: "⚠️ Definitief verwijderen",
    prompt:
      "Waarom moet dit rapport definitief worden gewist? Alle rapportregels en de normale rapportaudit worden onherstelbaar verwijderd.",
    confirmation:
      "Dit wist het rapport en alle rapportgebonden gegevens definitief. Alleen een minimale beheerregistratie blijft bestaan. Doorgaan?",
    requiresReportDateConfirmation: true,
  };
}
